import {FC, ReactElement} from 'react';
import {ModalCloseBtn, ModalHeaderTitle, ModalHeaderWrapper} from './ModalHeader.styles';
import {Close} from '@carbon/icons-react';
import {theme} from '@styles/theme';
import Text from "@atoms/Text";

interface ModalHeaderProps {
  title: string;
  onClose: () => void;
  closeBtnSize?: number;
  hideCloseBtn?: boolean;
  borderRadius?: string;
  iconElement?: ReactElement;
}

const ModalHeader: FC<ModalHeaderProps> = ({
  title,
  onClose,
  closeBtnSize = 16,
  hideCloseBtn,
  iconElement,
  borderRadius,
}) => {
  return (
    <ModalHeaderWrapper borderRadius={borderRadius}>
      <ModalHeaderTitle>
        {iconElement && iconElement}
        <Text text={title} type="subtitleR" />
      </ModalHeaderTitle>
      {!hideCloseBtn && (
        <ModalCloseBtn onClick={onClose}>
          <Close size={closeBtnSize} fill={theme.colors.basic03} />
        </ModalCloseBtn>
      )}
    </ModalHeaderWrapper>
  );
};

export default ModalHeader;
